import { useState, useContext, useEffect } from 'react';
import { Badge, Button, Card, Col, Form, Modal, Row, Table } from 'react-bootstrap';
import { FaBan, FaCheckCircle, FaEye, FaPlus, FaTimesCircle, FaUser, FaUserShield } from 'react-icons/fa';
import '../../../assets/css/Admin/SubAdmin/SubAdmin.css';
import AdminMasterLayout from '../../../layouts/Admin/AdminMasterLayout';
import axios from "axios";
import AppContext from "../../../context/AppContext";

const SubAdmin = () => {
  const { baseUrl, RegExpChecker } = useContext(AppContext);
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [adminfirstname, setadminFirstName] = useState("");
  const [adminlastname, setadminLastName] = useState("");
  const [adminemail, setadminEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSuperAdmin, setisSuperAdmin] = useState(false);
  const [errors, setErrors] = useState({
    firstname: "",
    lastname: "",
    email: "",
    password: "",
  });


  // Sub-admins list — fetched from backend
  const [subAdmins, setSubAdmins] = useState([]);
  const [loadingList, setLoadingList] = useState(true);

  // Fetch all sub-admins from backend
  const fetchSubAdmins = () => {
    setLoadingList(true);
    const token = localStorage.getItem("authToken");

    axios
      .get(`${baseUrl}/admin/subadmin/viewAllSubadmins`, {
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      })
      .then((response) => {
        setLoadingList(false);
        if (response.data.success === true) {
          const rawList = response.data.data || [];
          const normalized = rawList.map((admin) => ({
            id: admin.id,
            firstName: admin.adminfirstname,
            lastName: admin.adminlastname,
            email: admin.adminemail,
            isSuperAdmin: admin.isSuperAdmin === 1 || admin.isSuperAdmin === true,
            status: admin.status || 'Active',
            permissions:
              admin.isSuperAdmin === 1 || admin.isSuperAdmin === true
                ? 'Full Access'
                : 'Limited Access',
            createdDate: admin.created_at
              ? new Date(admin.created_at).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric',
                })
              : '-',
            avatar: `${(admin.adminfirstname || '?')[0] || ''}${(admin.adminlastname || '')[0] || ''}`.toUpperCase(),
          }));
          setSubAdmins(normalized);
        }
      })
      .catch((error) => {
        setLoadingList(false);
        console.log(error);
      });
  };

  useEffect(() => {
    fetchSubAdmins();
  }, []);

  // Handle modal open/close
  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("adminfirstname", adminfirstname);
    formData.append("adminlastname", adminlastname);
    formData.append("adminemail", adminemail);
    formData.append("password", password);
    formData.append("isSuperAdmin", isSuperAdmin);

    const token = localStorage.getItem("authToken");

    //axios//
    axios.post(`${baseUrl}/admin/subadmin/createsubadmin`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": `Bearer ${token}`,
      },
    })
      .then((response) => {
        console.log(response.data);
        setadminFirstName("");
        setadminLastName("");
        setadminEmail("");
        setPassword("");
        setisSuperAdmin(false);
        if (response.data.success === true) {
          fetchSubAdmins();
          handleCloseModal();
        } else {
          alert("Invalid Credentials. Try again with correct one.");
        }
      })
      .catch((error) => {
        console.log(error);
        alert("Network Error! Please try again.");
      });
  };

  // Handle view modal
  const handleViewAdmin = (admin) => {
    setSelectedAdmin(admin);
    setShowViewModal(true);
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
    setSelectedAdmin(null);
  };

  // Handle disable admin
  const handleDisableAdmin = (adminId) => {
    if (window.confirm('Are you sure you want to disable this sub-admin?')) {
      setSubAdmins(subAdmins.map(admin =>
        admin.id === adminId ? { ...admin, status: 'Inactive' } : admin
      ));
    }
  };

  // Get status badge variant
  const getStatusBadge = (status) => {
    return status === 'Active' ? 'success' : 'warning';
  };

  // Get permission badge variant
  const getPermissionBadge = (permission) => {
    switch (permission) {
      case 'Full Access':
        return 'primary';
      case 'Limited Access':
        return 'info';
      case 'View Only':
        return 'secondary';
      default:
        return 'secondary';
    }
  };


  return (
    <AdminMasterLayout screenName="sub-admin">
      <div className="sub-admin-container">

        {/* Page Header */}
        <div className="sub-admin-header">
          <div className="sub-admin-header-content">
            <h1 className="sub-admin-page-title">Sub-Admin Management</h1>
            <p className="sub-admin-page-subtitle">Manage sub-admins and their permissions</p>
          </div>
          <div className="sub-admin-header-action">
            <Button
              className="sub-admin-add-btn"
              onClick={handleOpenModal}
            >
              <FaPlus /> Add New Sub-Admin
            </Button>
          </div>
        </div>

        {/* Stats Summary */}
        <Row className="mb-3">
          <Col lg={12}>
            <Card className="sub-admin-stats-card">
              <Card.Body className="sub-admin-stats-body">
                <div className="sub-admin-stats-list">
                  <div className="sub-admin-stat-item">
                    <span className="sub-admin-stat-label">Total Sub-Admins</span>
                    <span className="sub-admin-stat-value">{subAdmins.length}</span>
                  </div>
                  <div className="sub-admin-stat-item">
                    <span className="sub-admin-stat-label">Super Admins</span>
                    <span className="sub-admin-stat-value sub-admin-stat-super">
                      {subAdmins.filter(a => a.isSuperAdmin).length}
                    </span>
                  </div>
                  <div className="sub-admin-stat-item">
                    <span className="sub-admin-stat-label">Active</span>
                    <span className="sub-admin-stat-value sub-admin-stat-active">
                      {subAdmins.filter(a => a.status === 'Active').length}
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Sub-Admins Table */}
        <Row className="sub-admin-table-row">
          <Col lg={12}>
            <Card className="sub-admin-table-card">
              <Card.Body className="sub-admin-table-body">
                <div className="sub-admin-table-wrapper">
                  <Table className="sub-admin-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>FIRST NAME</th>
                        <th>LAST NAME</th>
                        <th>EMAIL</th>
                        <th>IS SUPER ADMIN</th>
                        <th>PERMISSIONS</th>
                        <th>STATUS</th>
                        <th>CREATED DATE</th>
                        <th>ACTIONS</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loadingList ? (
                        <tr>
                          <td colSpan={9} className="text-center py-4">
                            Loading sub-admins...
                          </td>
                        </tr>
                      ) : subAdmins.length === 0 ? (
                        <tr>
                          <td colSpan={9} className="text-center py-4">
                            No sub-admins found. Click "Add New Sub-Admin" to create one.
                          </td>
                        </tr>
                      ) : (
                        subAdmins.map((admin, index) => (
                        <tr key={admin.id}>
                          <td>{index + 1}</td>
                          <td>
                            <div className="sub-admin-info">
                              <div className="sub-admin-avatar">{admin.avatar}</div>
                              <span className="sub-admin-name">{admin.firstName}</span>
                            </div>
                          </td>
                          <td className="sub-admin-lastname">{admin.lastName}</td>
                          <td className="sub-admin-email">{admin.email}</td>
                          <td>
                            {admin.isSuperAdmin ? (
                              <Badge bg="danger" className="sub-admin-super-badge">
                                <FaUserShield className="sub-admin-badge-icon" /> Yes
                              </Badge>
                            ) : (
                              <Badge bg="secondary" className="sub-admin-regular-badge">
                                <FaUser className="sub-admin-badge-icon" /> No
                              </Badge>
                            )}
                          </td>
                          <td>
                            <Badge
                              bg={getPermissionBadge(admin.permissions)}
                              className="sub-admin-permission-badge"
                            >
                              {admin.permissions}
                            </Badge>
                          </td>
                          <td>
                            <Badge
                              bg={getStatusBadge(admin.status)}
                              className="sub-admin-status-badge"
                            >
                              {admin.status === 'Active' ? (
                                <><FaCheckCircle className="sub-admin-badge-icon" /> Active</>
                              ) : (
                                <><FaTimesCircle className="sub-admin-badge-icon" /> Inactive</>
                              )}
                            </Badge>
                          </td>
                          <td>{admin.createdDate}</td>
                          <td>
                            <div className="sub-admin-action-buttons">
                              <Button
                                className="sub-admin-view-btn"
                                size="sm"
                                title="View Details"
                                onClick={() => handleViewAdmin(admin)}
                              >
                                <FaEye /> View
                              </Button>
                              {!admin.isSuperAdmin && admin.status !== 'Inactive' && (
                                <Button
                                  className="sub-admin-disable-btn"
                                  size="sm"
                                  title="Disable Sub-Admin"
                                  onClick={() => handleDisableAdmin(admin.id)}
                                >
                                  <FaBan /> Disable
                                </Button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))
                      )}
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Add Sub-Admin Modal */}
        <Modal
          show={showModal}
          onHide={handleCloseModal}
          centered
          className="sub-admin-modal"
        >
          <Modal.Header closeButton className="sub-admin-modal-header">
            <Modal.Title className="sub-admin-modal-title">
              <FaPlus /> Add New Sub-Admin
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="sub-admin-modal-body">
            <Form >
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="sub-admin-form-label">First Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="firstName"
                      placeholder="Enter first name"
                      value={adminfirstname}
                      onChange={(event) => {
                        const value = event.target.value;
                        setadminFirstName(value);
                        const regError = RegExpChecker("username", value);
                        setErrors((prev) => ({
                          ...prev,
                          firstname: value && regError ? regError : "",
                        }));
                      }}
                      className="sub-admin-form-input"
                      required
                    />
                    {errors.firstname && (
                      <div className="text-danger small mt-1">{errors.firstname}</div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className="sub-admin-form-label">Last Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="lastName"
                      placeholder="Enter last name"
                      value={adminlastname}
                      onChange={(event) => {
                        const value = event.target.value;
                        setadminLastName(value);
                        const regError = RegExpChecker("username", value);
                        setErrors((prev) => ({
                          ...prev,
                          lastname: value && regError ? regError : "",
                        }));
                      }}
                      className="sub-admin-form-input"
                      required
                    />
                    {errors.lastname && (
                      <div className="text-danger small mt-1">{errors.lastname}</div>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Form.Label className="sub-admin-form-label">Email Address</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Enter email address"
                  value={adminemail}
                  onChange={(event) => {
                    const value = event.target.value;
                    setadminEmail(value);
                    let error = "";
                    const regError = RegExpChecker("email", value);

                    if (value && regError) {
                      error = regError;
                    }

                    setErrors((prev) => ({
                      ...prev,
                      email: error,
                    }));
                  }}
                  className="sub-admin-form-input"
                  required
                />
                {errors.email && (
                  <div className="text-danger small mt-1">{errors.email}</div>
                )}
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label className="sub-admin-form-label">Password</Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  placeholder="Enter password"
                  value={password}
                  onChange={(event) => {
                    const value = event.target.value;
                    setPassword(value);
                    let error = "";
                    const regError = RegExpChecker("password", value);
                    if (value && regError) {
                      error = regError;
                    }
                    setErrors((prev) => ({
                      ...prev,
                      password: error,
                    }));
                  }}
                  className="sub-admin-form-input"
                  required
                />
                {errors.password && (
                  <div className="text-danger small mt-1">{errors.password}</div>
                )}
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Check
                  type="checkbox"
                  name="isSuperAdmin"
                  label="Is Super Admin"
                  checked={isSuperAdmin}
                  onChange={(event) => {
                    setisSuperAdmin(event.target.checked);
                  }}
                  className="sub-admin-form-checkbox"
                />
                <Form.Text className="sub-admin-form-help">
                  Super admins have full access to all features and settings
                </Form.Text>
              </Form.Group>

              <div className="sub-admin-modal-footer">
                <Button
                  variant="secondary"
                  onClick={handleCloseModal}
                  className="sub-admin-cancel-btn"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  className="sub-admin-submit-btn"
                  onClick={handleSubmit}
                >
                  <FaPlus /> Add Sub-Admin
                </Button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>

        {/* View Sub-Admin Details Modal */}
        <Modal
          show={showViewModal}
          onHide={handleCloseViewModal}
          centered
          size="lg"
          className="sub-admin-view-modal"
        >
          <Modal.Header closeButton className="sub-admin-view-modal-header">
            <Modal.Title className="sub-admin-view-modal-title">
              <FaEye /> Sub-Admin Details
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="sub-admin-view-modal-body">
            {selectedAdmin && (
              <div className="sub-admin-details-container">
                {/* Profile Section */}
                <div className="sub-admin-details-profile">
                  <div className="sub-admin-details-avatar-large">
                    {selectedAdmin.avatar}
                  </div>
                  <div className="sub-admin-details-profile-info">
                    <h3 className="sub-admin-details-name">
                      {selectedAdmin.firstName} {selectedAdmin.lastName}
                    </h3>
                    <p className="sub-admin-details-email">{selectedAdmin.email}</p>
                    <div className="sub-admin-details-badges">
                      {selectedAdmin.isSuperAdmin ? (
                        <Badge bg="danger" className="sub-admin-details-badge">
                          <FaUserShield /> Super Admin
                        </Badge>
                      ) : (
                        <Badge bg="secondary" className="sub-admin-details-badge">
                          <FaUser /> Sub-Admin
                        </Badge>
                      )}
                      <Badge
                        bg={selectedAdmin.status === 'Active' ? 'success' : 'warning'}
                        className="sub-admin-details-badge"
                      >
                        {selectedAdmin.status === 'Active' ? (
                          <><FaCheckCircle /> Active</>
                        ) : (
                          <><FaTimesCircle /> Inactive</>
                        )}
                      </Badge>
                    </div>
                  </div>
                </div>

                {/* Details Grid */}
                <Row className="sub-admin-details-grid">
                  <Col md={6}>
                    <div className="sub-admin-detail-item">
                      <label className="sub-admin-detail-label">First Name</label>
                      <p className="sub-admin-detail-value">{selectedAdmin.firstName}</p>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="sub-admin-detail-item">
                      <label className="sub-admin-detail-label">Last Name</label>
                      <p className="sub-admin-detail-value">{selectedAdmin.lastName}</p>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="sub-admin-detail-item">
                      <label className="sub-admin-detail-label">Email Address</label>
                      <p className="sub-admin-detail-value">{selectedAdmin.email}</p>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="sub-admin-detail-item">
                      <label className="sub-admin-detail-label">Created Date</label>
                      <p className="sub-admin-detail-value">{selectedAdmin.createdDate}</p>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="sub-admin-detail-item">
                      <label className="sub-admin-detail-label">Role</label>
                      <p className="sub-admin-detail-value">
                        {selectedAdmin.isSuperAdmin ? 'Super Administrator' : 'Sub-Administrator'}
                      </p>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="sub-admin-detail-item">
                      <label className="sub-admin-detail-label">Permissions Level</label>
                      <Badge
                        bg={getPermissionBadge(selectedAdmin.permissions)}
                        className="sub-admin-detail-permission-badge"
                      >
                        {selectedAdmin.permissions}
                      </Badge>
                    </div>
                  </Col>
                </Row>


                {/* Activity Section */}
                <div className="sub-admin-activity-section">
                  <h5 className="sub-admin-activity-title">Recent Activity</h5>
                  <div className="sub-admin-activity-list">
                    <div className="sub-admin-activity-item">
                      <span className="sub-admin-activity-time">2 hours ago</span>
                      <span className="sub-admin-activity-text">Updated customer profile #1234</span>
                    </div>
                    <div className="sub-admin-activity-item">
                      <span className="sub-admin-activity-time">5 hours ago</span>
                      <span className="sub-admin-activity-text">Approved driver verification</span>
                    </div>
                    <div className="sub-admin-activity-item">
                      <span className="sub-admin-activity-time">Yesterday</span>
                      <span className="sub-admin-activity-text">Logged into dashboard</span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer className="sub-admin-view-modal-footer">
            <Button
              variant="secondary"
              onClick={handleCloseViewModal}
              className="sub-admin-view-close-btn"
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

      </div>
    </AdminMasterLayout>
  );
};

export default SubAdmin;